<!-- Load login custom page styles -->
<style lang="scss">
@import "@/assets/sass/pages/login/login-1.scss";
</style>
<script>
import { API_URL, MEDIA_URL } from "@/core/api";
import Bootstrap from "@/assets/plugins/formvalidation/dist/es6/plugins/Bootstrap";
import { mapGetters, mapState } from "vuex";
import { LOGIN, LOGOUT, REGISTER } from "@/core/services/store/auth.module";
import Switcher from "@/view/front/components/switcher";
import Footer from "@/view/front/components/footer";
import Navbar from "@/view/front/components/navbar";

export default {
  name: "login-1",
  data() {
    return {
      jobSeekerSignUp: false,
      recruiterSignUp: true,
      agencySignUp: false,
      state: "signin",

      apiUrl: API_URL,
      novalidate: "",
    };
  },
  computed: {
    ...mapState({
      errors: (state) => state.auth.errors,
    }),

    ...mapGetters(["currentUser"]),

    backgroundImage() {
      return (
        process.env.BASE_URL + "media/svg/illustrations/login-visual-1.svg"
      );
    },
  },

  mounted() {
    var link = !!document.querySelector("link[rel='canonical']")
      ? document.querySelector("link[rel='canonical']")
      : document.createElement("link");
    link.setAttribute("rel", "canonical");
    link.setAttribute(
      "href",
      location.protocol + "//" + location.host + location.pathname
    );
    document.head.appendChild(link);
  },

  components: {
    Navbar,
    Switcher,
    Footer,
  },
  methods: {
    AuthProvider(provider) {
      var self = this;

      this.$auth
        .authenticate(provider)
        .then((response) => {
          self.SocialLogin(provider, response);
        })
        .catch((err) => {});
    },
  },
  metaInfo: function() {
    return {
      title: "Command the brilliance in your job interviews - Book Session Now",
      meta: [
        {
          name: "description",
          content:
            "Book your session with Job4u.pk Team to get command the brilliance in your job interview. We always love to assist you for better command in your interviews",
        },
      ],
    };
  },
};
</script>
<template>
  <div class="">
    <div>
      <!-- Navbar STart -->
      <Navbar />
      <!--end header-->
      <!-- Navbar End -->
    </div>
    <div>
      <div class="position-relative">
        <div class="shape overflow-hidden text-white">
          <svg
            viewBox="0 0 2880 48"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M0 48H1437.5H2880V0H2160C1442.5 52 720 0 720 0H0V48Z"
              fill="currentColor"
            ></path>
          </svg>
        </div>
      </div>
      <section class="contact_image_bg">
        <div class="container">
          <div class="row align-items-center">
            <div class="col-lg-4 auth_heading">
              Get ready and breeze
              <span class="font-weight-bolder"> through it!</span>
            </div>
            <div class="col-lg-5 col-md-6">
              <div class="card shadow p-9 px-10">
                <div class="card-body p-0">
                  <h4 class="card-title auth_title">Book now</h4>
                  <p class="card-title auth_disctption">
                    Book a consulting session to command the brilliance in job
                    interviews.
                  </p>
                  <div class="custom-form mt-4">
                    <div id="message"></div>
                    <meta
                      http-equiv="Content-Type"
                      content="text/html;charset=UTF-8"
                    />
                    <form
                      novalidate="novalidate"
                      id="__vtigerWebForm"
                      name="Command the Brilliance in Job Interviews"
                      action="https://crm.job4u.pk/modules/Webforms/capture.php"
                      method="post"
                      accept-charset="utf-8"
                      enctype="multipart/form-data"
                    >
                      <input
                        type="hidden"
                        name="__vtrftk"
                        value="sid:776f96c0a8ba5afeb5339d761998d1d2b66bf34c,1654734137"
                      />
                      <input
                        type="hidden"
                        name="publicid"
                        value="0f44e2b1ad12dbbf6967224086fe8970"
                      />
                      <input type="hidden" name="urlencodeenable" value="1" />
                      <input
                        type="hidden"
                        name="name"
                        value="Command the Brilliance in Job Interviews"
                      />
                      <div class="row">
                        <div class="col-md-12">
                          <div
                            class="form-group auth_inputs_icon position-relative auth_inputs_img2"
                          >
                            <img
                              src="/images/login_contact/usernameemail.svg"
                              alt=""
                            />
                            <input
                              name="firstname"
                              type="text"
                              class="form-control pl-5"
                              placeholder="Your first name"
                              data-label=""
                              value=""
                              required=""
                            />
                          </div>
                        </div>
                        <div class="col-md-12">
                          <div
                            class="form-group auth_inputs_icon position-relative auth_inputs_img2"
                          >
                            <img
                              src="/images/login_contact/usernameemail.svg"
                              alt=""
                            />
                            <input
                              name="lastname"
                              type="text"
                              class="form-control pl-5"
                              placeholder="Your last name"
                              data-label=""
                              value=""
                              required=""
                            />
                          </div>
                        </div>

                        <div class="col-md-12">
                          <div
                            class="form-group auth_inputs_icon position-relative auth_inputs_img2"
                          >
                            <img src="/images/login_contact/email.svg" alt="" />
                            <input
                              name="email"
                              data-label=""
                              value=""
                              required=""
                              type="email"
                              class="form-control pl-5"
                              placeholder="Your email"
                            />
                          </div>
                        </div>

                        <div class="col-md-12">
                          <div
                            class="form-group auth_inputs_icon position-relative auth_inputs_img2"
                          >
                            <img src="/images/login_contact/phone.svg" alt="" />
                            <input
                              name="mobile"
                              data-label=""
                              value=""
                              required=""
                              type="text"
                              class="form-control pl-5"
                              placeholder="Your mobile number"
                            />
                          </div>
                        </div>

                        <div class="col-md-12">
                          <div
                            class="form-group auth_inputs_icon position-relative"
                          >
                            <textarea
                              name="description"
                              rows="4"
                              class="form-control pl-5"
                              placeholder="Your Message"
                            ></textarea>
                          </div>
                        </div>
                        <select
                          name="leadsource"
                          data-label="leadsource"
                          hidden=""
                        >
                          <option value="">Select Value</option>
                          <option value="Cold Call">Cold Call</option>
                          <option value="Existing Customer">
                            Existing Customer
                          </option>
                          <option value="Self Generated">
                            Self Generated
                          </option>
                          <option value="Employee">Employee</option>
                          <option value="Partner">Partner</option>
                          <option value="Public Relations">
                            Public Relations
                          </option>
                          <option value="Direct Mail">Direct Mail</option>
                          <option value="Conference">Conference</option>
                          <option value="Trade Show">Trade Show</option>
                          <option value="Website">Website</option>
                          <option value="Word of mouth">
                            Word of mouth
                          </option>
                          <option value="Other">Other</option>
                          <option
                            value="Website - Command the Interview Brilliance"
                            selected=""
                          >
                            Website - Command the Interview Brilliance
                          </option>
                        </select>
                        <input
                          type="hidden"
                          id="captchaUrl"
                          value="https://crm.job4u.pk/modules/Settings/Webforms/actions/CheckCaptcha.php"
                        />
                        <input type="hidden" id="recaptcha_validation_value" />
                      </div>

                      <div class="row">
                        <div class="col-sm-12 text-center">
                          <input
                            type="submit"
                            id="submit"
                            name="send"
                            @click="onSubmitLogin()"
                            class="submitBnt btn btn-block"
                            ref="kt_login_signin_submit"
                            value="Send Message"
                          />
                          <div id="simple-msg"></div>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
    <div>
      <Footer />
      <Switcher />
      <a
        href="javascript: void(0);"
        class="btn btn-icon btn-soft-primary back-to-top"
        id="back-to-top"
        v-scroll-to="'#topnav'"
      >
        <arrow-up-icon class="icons"></arrow-up-icon>
      </a>
      <!-- Footer Start -->
      <!--end footer-->
    </div>
  </div>
</template>
<style scoped>
footer span,
footer a,
footer p,
footer h4,
footer label {
  color: white !important;
}
</style>
<script type="text/javascript">
window.onload = function() {
  var N = navigator.appName,
    ua = navigator.userAgent,
    tem;
  var M = ua.match(/(opera|chrome|safari|firefox|msie)\/?\s*(\.?\d+(\.\d+)*)/i);
  if (M && (tem = ua.match(/version\/([\.\d]+)/i)) != null) M[2] = tem[1];
  M = M ? [M[1], M[2]] : [N, navigator.appVersion, "-?"];
  var browserName = M[0];
  var form = document.getElementById("__vtigerWebForm"),
    inputs = form.elements;
  form.onsubmit = function() {
    var required = [],
      att,
      val;
    for (var i = 0; i < inputs.length; i++) {
      att = inputs[i].getAttribute("required");
      val = inputs[i].value;
      type = inputs[i].type;
      if (type == "email") {
        if (val != "") {
          var elemLabel = inputs[i].getAttribute("label");
          var emailFilter = /^[_/a-zA-Z0-9]+([!"#$%&()*+,./:;<=>?\^_`{|}~-]?[a-zA-Z0-9/_/-])*@[a-zA-Z0-9]+([\_\-\.]?[a-zA-Z0-9]+)*\.([\-\_]?[a-zA-Z0-9])+(\.?[a-zA-Z0-9]+)?$/;
          var illegalChars = /[\(\)\<\>\,\;\:\"\[\]]/;
          if (!emailFilter.test(val)) {
            alert(
              "For " + elemLabel + " field please enter valid email address"
            );
            return false;
          } else if (val.match(illegalChars)) {
            alert(elemLabel + " field contains illegal characters");
            return false;
          }
        }
      }
      if (att != null) {
        if (val.replace(/^\s+|\s+$/g, "") == "") {
          required.push(inputs[i].getAttribute("label"));
        }
      }
    }
    if (required.length > 0) {
      alert("The following fields are required: " + required.join());
      return false;
    }
    var numberTypeInputs = document.querySelectorAll("input[type=number]");
    for (var i = 0; i < numberTypeInputs.length; i++) {
      val = numberTypeInputs[i].value;
      var elemLabel = numberTypeInputs[i].getAttribute("label");
      var elemDataType = numberTypeInputs[i].getAttribute("datatype");
      if (val != "") {
        if (elemDataType == "double") {
          var numRegex = /^[+-]?\d+(\.\d+)?$/;
        } else {
          var numRegex = /^[+-]?\d+$/;
        }
        if (!numRegex.test(val)) {
          alert("For " + elemLabel + " field please enter valid number");
          return false;
        }
      }
    }
    var dateTypeInputs = document.querySelectorAll("input[type=date]");
    for (var i = 0; i < dateTypeInputs.length; i++) {
      dateVal = dateTypeInputs[i].value;
      var elemLabel = dateTypeInputs[i].getAttribute("label");
      if (dateVal != "") {
        var dateRegex = /^[1-9][0-9]{3}-(0[1-9]|1[0-2]|[1-9]{1})-(0[1-9]|[1-2][0-9]|3[0-1]|[1-9]{1})$/;
        if (!dateRegex.test(dateVal)) {
          alert(
            "For " +
              elemLabel +
              " field please enter valid date in required format"
          );
          return false;
        }
      }
    }
    var inputElems = document.getElementsByTagName("input");
    var totalFileSize = 0;
    for (var i = 0; i < inputElems.length; i++) {
      if (inputElems[i].type.toLowerCase() === "file") {
        var file = inputElems[i].files[0];
        if (typeof file !== "undefined") {
          var totalFileSize = totalFileSize + file.size;
        }
      }
    }
    if (totalFileSize > 52428800) {
      alert("Maximum allowed file size including all files is 50MB.");
      return false;
    }
    var recaptchaValidationValue = document.getElementById(
      "recaptcha_validation_value"
    ).value;
    if (recaptchaValidationValue != true) {
      var recaptchaResponseElement = document.getElementsByName(
        "recaptcha_response_field"
      )[0].value;
      var recaptchaChallengeElement = document.getElementsByName(
        "recaptcha_challenge_field"
      )[0].value;
      var captchaUrl = document.getElementById("captchaUrl").value;
      var url =
        captchaUrl + "?recaptcha_response_field=" + recaptchaResponseElement;
      url =
        url +
        "&recaptcha_challenge_field=" +
        recaptchaChallengeElement +
        "&callback=JSONPCallback";
      jsonp.fetch(url);
      return false;
    }
  };
};
var jsonp = {
  callbackCounter: 0,
  fetch: function(url) {
    url = url + "&callId=" + this.callbackCounter;
    var scriptTag = document.createElement("SCRIPT");
    scriptTag.src = url;
    scriptTag.async = true;
    scriptTag.id = "JSONPCallback_" + this.callbackCounter;
    scriptTag.type = "text/javascript";
    document.getElementsByTagName("HEAD")[0].appendChild(scriptTag);
    this.callbackCounter++;
  },
};
function JSONPCallback(data) {
  if (data.result.success == true) {
    document.getElementById("recaptcha_validation_value").value = true;
    var form = document.getElementById("__vtigerWebForm");
    form.submit();
  } else {
    document.getElementById("recaptcha_reload").click();
    alert("you entered wrong captcha");
  }
  var element = document.getElementById("JSONPCallback_" + data.result.callId);
  element.parentNode.removeChild(element);
}
</script>
